/* Compare table extra spec rows (case size, water resistance, warranty, movement, power reserve, glass).
   Fills the .compare-extra rows added in layout/theme.liquid from data rendered by templates/product.compare.liquid.
   Layout: the whole compare is rendered as a CSS table (see gastrosol.css), so every row is a table-row and
   every cell a table-cell - columns align natively. normalize() makes sure each row has a leading label cell. */
(function () {
  'use strict';
  var ROWS = [
    ['compare-case-size', 'clone-compare-case-size'],
    ['compare-water-resistance', 'clone-compare-water-resistance'],
    ['compare-warranty', 'clone-compare-warranty'],
    ['compare-movement', 'clone-compare-movement'],
    ['compare-power-reserve', 'clone-compare-power-reserve'],
    ['compare-glass', 'clone-compare-glass']
  ];
  var EMPTY = '<div class="compare-spec">&mdash;</div>';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var table = document.querySelector('.compare__table');
    if (!table) return;
    var cache = {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function q(sel) { return table.querySelector(sel); }

    function productLis(ul) {
      if (!ul) return [];
      return Array.prototype.filter.call(ul.querySelectorAll(':scope > li'), function (li) {
        if (li.classList.contains('label') || li.classList.contains('cmp-pad')) return false;
        return !!(li.querySelector('[data-handle]') || li.querySelector('a[href*="/products/"]'));
      });
    }

    function handleOf(li) {
      var el = li.querySelector('[data-handle]');
      if (el && el.getAttribute('data-handle')) return el.getAttribute('data-handle');
      var a = li.querySelector('a[href*="/products/"]');
      if (a) {
        var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        if (m) return m[1];
      }
      return null;
    }

    function refRow() {
      var name = q('ul.compare-name'), img = q('ul.compare-image');
      if (name && productLis(name).length) return name;
      if (img && productLis(img).length) return img;
      return name || img;
    }

    function fetchSpecs(handle) {
      if (!handle) return Promise.resolve(null);
      if (cache[handle]) return cache[handle];
      cache[handle] = fetch(root + 'products/' + handle + '?view=compare', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var specs = {};
          ROWS.forEach(function (row) {
            var el = doc.querySelector('.' + row[1]);
            specs[row[0]] = el ? el.innerHTML : EMPTY;
          });
          return specs;
        })
        .catch(function () { delete cache[handle]; return null; });
      return cache[handle];
    }

    /* Ensure every row of the table has a leading label cell so the columns line up.
       Rows whose label is rendered by the theme as a ::before pseudo-element are left alone. */
    function normalize() {
      var name = q('ul.compare-name');
      if (!name) return;
      var n = productLis(name).length;
      if (!n) return;
      Array.prototype.forEach.call(table.querySelectorAll('.table > ul'), function (ul) {
        var pc = '';
        try { pc = getComputedStyle(ul, '::before').content; } catch (e) { }
        var hasPseudoLabel = pc && pc !== 'none' && pc !== 'normal' && pc !== '""';
        if (hasPseudoLabel) return;
        var lis = ul.querySelectorAll(':scope > li');
        if (lis.length === n && !(lis[0] && lis[0].classList.contains('label'))) {
          var li = document.createElement('li');
          li.className = 'label';
          li.textContent = ul.getAttribute('data-label') || '';
          ul.insertBefore(li, ul.firstChild);
        }
      });
    }

    var syncing = false, pending = false;
    function sync() {
      if (syncing) { pending = true; return; }
      syncing = true;
      var src = refRow();
      var handles = src ? productLis(src).map(handleOf) : [];
      Promise.all(handles.map(fetchSpecs)).then(function (list) {
        ROWS.forEach(function (row) {
          var ul = q('ul.' + row[0]);
          if (!ul) return;
          ul.innerHTML = '';
          if (!list.length) return;
          var label = document.createElement('li');
          label.className = 'label';
          label.textContent = ul.getAttribute('data-label') || '';
          ul.appendChild(label);
          list.forEach(function (specs) {
            var li = document.createElement('li');
            li.innerHTML = (specs && specs[row[0]]) || EMPTY;
            ul.appendChild(li);
          });
        });
        normalize();
        syncing = false;
        if (pending) { pending = false; sync(); }
      }).catch(function () { syncing = false; });
    }

    var t = null;
    function schedule() {
      clearTimeout(t);
      t = setTimeout(sync, 120);
    }
    var mo = new MutationObserver(schedule);
    var nr = q('ul.compare-name'), ir = q('ul.compare-image');
    if (ir) mo.observe(ir, { childList: true });
    if (nr) mo.observe(nr, { childList: true });
    schedule();
  });
})();
